export default __webpack_public_path__ + "static/media/slider-info-right-light-2.357b61fe.png";